import { connect } from "react-redux"
import { withNamespaces } from "react-i18next"

import { gamificationStatsProps } from "QuorumGrassroots/widgets/GamificationStats/selectors"

import { GamificationStatsWidget } from "QuorumGrassroots/widgets/GamificationStats/components/index"

export default withNamespaces()(connect(gamificationStatsProps, null)(GamificationStatsWidget))
